import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Widget = _resolveComponent("Widget")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["widgets", {snapshot: $props.snapshot}])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.widget_groups, (group) => {
      return (_openBlock(), _createElementBlock("div", {
        key: group.key,
        class: _normalizeClass(["widget-group", ['widget-group-' + group.type]])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.widgets, (widget, idx) => {
          return (_openBlock(), _createBlock(_component_Widget, {
            key: idx,
            ref_for: true,
            ref: "widget",
            widget: widget,
            snapshot: $props.snapshot
          }, null, 8 /* PROPS */, ["widget", "snapshot"]))
        }), 128 /* KEYED_FRAGMENT */))
      ], 2 /* CLASS */))
    }), 128 /* KEYED_FRAGMENT */))
  ], 2 /* CLASS */))
}